import { ReactNode } from 'react';

import { Tooltip, tokens, Typography, Box } from '@cast/design-system';
import { K8sProvider } from '@cast/shared-types';

import { LogoFullSvg, LogoSmallSvg } from '../../assets/svg';

import { getProviderTooltipMessage } from './_utils';
import { K8sProviderIcon } from './K8sProviderIcon';
import { KarpenterLogo } from '../KarpenterLogo';

type Props = {
  provider?: `${K8sProvider}`;
  castEnabled?: boolean;
  isKentManagedCluster?: boolean;
  iconSplitter?: ReactNode;
  size?: number;
  spacing?: number;
  variant?: 'small' | 'large';
};

export const K8sProviderIcons = ({
  provider,
  castEnabled = false,
  isKentManagedCluster = false,
  size = 26,
  iconSplitter,
  variant = 'small',
}: Props) => {
  const message = getProviderTooltipMessage({
    provider,
    castEnabled,
    isKentManagedCluster,
  });
  const logoColor = tokens.theme.fg.structural.primary;
  const showSplitter = provider && (castEnabled || isKentManagedCluster);

  return (
    <Tooltip title={message}>
      <Box
        display="inline-flex"
        alignItems="center"
        gap={variant === 'small' ? 4 : 6}
      >
        {provider && <K8sProviderIcon provider={provider} size={size} />}

        {showSplitter &&
          (iconSplitter || (
            <Typography
              fontWeight="fontWeightMedium"
              variant={variant === 'small' ? 'P12R' : 'P16R'}
              sx={{ color: tokens.theme.fg.structural.primary }}
            >
              +
            </Typography>
          ))}

        {castEnabled &&
          (variant === 'small' ? (
            <LogoSmallSvg
              height={size}
              color={logoColor}
              data-testid="cast-ai-logo"
            />
          ) : (
            <LogoFullSvg
              height={size}
              color={logoColor}
              data-testid="cast-ai-logo"
            />
          ))}

        {isKentManagedCluster && !castEnabled && (
          // since karpenter logo is smaller than cast ai logo, we add to the size
          <KarpenterLogo size={size + 2} />
        )}
      </Box>
    </Tooltip>
  );
};
